import Nature from '@mui/icons-material/Nature';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function NatureIcon(props: FixMe) {
  return <Nature {...props} />;
}

export default NatureIcon;
